import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HelpContentComponentConfig } from '../../../../UI-Lib/Help-Tooltip';
import { HelpModule } from '../../../../UI-Lib/Help-Tooltip/help.module';
import { ParcelIconComponent } from '../../../Parcel/Icon/parcelIcon.component';
import { ParcelListControlRow } from '../../Models/parcelList';
import { ParcelTileTaxableValuesTooltipComponent } from './Taxable-Values-Tooltip/parcelTileTaxableValues.component';

@Component({
    selector: 'parcel-tile',
    templateUrl: './parcelTile.component.html',
    styleUrls: ['./parcelTile.component.scss'],
    imports: [CommonModule, ParcelIconComponent, HelpModule],
})
export class ParcelTileComponent {
    @Input() item: ParcelListControlRow;
    @Input() stateAllowConsolidating: boolean;
    @Input() ppReturnPreparationAllowed: boolean;
    @Output() navigateToParcel: EventEmitter<number> = new EventEmitter();

    taxableValueTooltip: HelpContentComponentConfig<any, any> = {
        component: ParcelTileTaxableValuesTooltipComponent,
        componentParams: {},
    };
}
